import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import Input from "../../../atoms/Input";
import {
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import DynamicText from "../../../molecules/DynamicText";
import { Bucket } from "../../../../api/config/apiConfig";

const WorksheetImportDownload = ({ surveyData, formContent }) => {
  const isEdit = false; // Always false for download/print view

  // Helper styles for print optimization
  const cellStyle = {
    padding: "4px 8px", // Reduced padding
    fontSize: "12px", // Smaller font
  };

  const headerCellStyle = {
    ...cellStyle,
    fontWeight: "bold",
    width: "30%",
    backgroundColor: "#f5f5f5",
  };

  return (
    <>
      <div className="mx-4 page-break-inside-avoid">
        <div>
          <div className="d-block d-sm-flex align-items-center pb-1 pt-0 ">
            <div className="d-flex align-items-center justify-content-center w-100">
              <p className="ps-0 mb-2 head-top"> Work Sheet Import</p>
            </div>
          </div>
        </div>
        
        {/* file detail*/}
        <div className="contact-detail d-flex mt-1 mb-2">
          {/* left col */}
          <div className="left-col w-50 text-start">
            <Typography variant="body1" component="div">
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Name:</b>{" "}
                <span className="ms-1">
                  {formContent?.customerName || "-"}
                </span>
              </p>
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Organization:</b>{" "}
                <span className="ms-1">
                  {formContent?.organization || "-"}
                </span>
              </p>
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Delivery Address:</b>{" "}
                <span className="ms-1">
                  {formContent?.deliveryAddres || "-"}
                </span>
              </p>
            </Typography>
          </div>
          {/* right col */}
          <div className="right-col w-50 d-flex flex-column align-items-end pe-2">
            <Typography variant="body1" className="text-start w-100" component="div">
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> File No.:</b>{" "}
                <span className="ms-1">
                  {formContent?.fileNo || "-"}
                </span>
              </p>
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Contact No.:</b>{" "}
                <span className="ms-1">
                  {formContent?.contactNo && formContent?.contactNo !== "null"
                    ? formContent?.contactNo
                    : ""}
                </span>
              </p>
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Fax:</b>{" "}
                <span className="ms-1">
                  {formContent?.fax || ""}
                </span>
              </p>
              <p className="p-word mb-1 text-start" style={{ fontSize: "12px" }}>
                <b> Email:</b>{" "}
                <span className="ms-1">
                  {formContent?.email || ""}
                </span>
              </p>
            </Typography>
          </div>
        </div>

        {/* table */}
        <TableContainer component={Paper} className="mt-1 shadow-none border">
          <Table size="small">
            <TableBody>
              {/* Entitlement */}
              <TableRow>
                <TableCell style={headerCellStyle}>Entitlement</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.entitlement1 || "-"}
                </TableCell>
              </TableRow>
              
              {/* Estimated Weight */}
              <TableRow>
                <TableCell style={headerCellStyle}>Estimated Weight</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.estimatedWeight
                    ? `${formContent?.estimatedWeight}`
                    : "-"}
                </TableCell>
              </TableRow>
              
              {/* Actual Weight */}
              <TableRow>
                <TableCell style={headerCellStyle}>Actual Weight</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.actualWeight
                    ? `${formContent?.actualWeight}`
                    : "-"}
                </TableCell>
              </TableRow>
              
              {/* Estimated Volume */}
              <TableRow>
                <TableCell style={headerCellStyle}>Estimated Volume</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.estimatedVolume ? (
                    <>
                      {Number(formContent?.estimatedVolume)?.toFixed(2)} m
                      <sup>3</sup>
                    </>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
              
              {/* Actual Volume */}
              <TableRow>
                <TableCell style={headerCellStyle}>Actual Volume</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.actualVolume ? (
                    <>
                      {Number(formContent?.actualVolume)?.toFixed(2)} m
                      <sup>3</sup>
                    </>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
              
              {/* Delivery Started Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Delivery Started Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.deliveryStartedDate || "-"}
                </TableCell>
              </TableRow>
              
              {/* Delivery Completed Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Delivery Completed Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.deliveryCompletedDate || "-"}
                </TableCell>
              </TableRow>

              {/* Shifting Started Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Shifting Started Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.shiftingStartedDate || "-"}
                </TableCell>
              </TableRow>
              
              {/* Shifting Completed Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Shifting Completed Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.shiftingCompletedDate || "-"}
                </TableCell>
              </TableRow>
              
              {/* Warehouse In Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Warehouse In Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.wareHouseInDate || "-"}
                </TableCell>
              </TableRow>

              {/* Warehouse Out Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Warehouse Out Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.wareHouseOutDate || "-"}
                </TableCell>
              </TableRow>
              
              {/* Shipment Date */}
              <TableRow>
                <TableCell style={headerCellStyle}>Shipment Date</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.shipmentDate || "-"}
                </TableCell>
              </TableRow>

              {/* ORIGIN/Destination Country */}
              <TableRow>
                <TableCell style={headerCellStyle}>Origin / Destination</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.originDestination || "-"}
                </TableCell>
              </TableRow>

              {/* BOL/AWB No. */}
              <TableRow>
                <TableCell style={headerCellStyle}>BOL/AWB No.</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.bolAWBNo || "-"}
                </TableCell>
              </TableRow>

              {/* Container No. */}
              <TableRow>
                <TableCell style={headerCellStyle}>Container No.</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.containerNo || "-"}
                </TableCell>
              </TableRow>

              {/* Vessel */}
              <TableRow>
                <TableCell style={headerCellStyle}>Vessel</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.vessel || "-"}
                </TableCell>
              </TableRow>

              {/* ETD/ETA */}
              <TableRow>
                <TableCell style={headerCellStyle}>ETD/ETA</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.ETDbyETA || "-"}
                </TableCell>
              </TableRow>

              {/* ETA */}
              <TableRow>
                <TableCell style={headerCellStyle}>ETA</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.ETA || "-"}
                </TableCell>
              </TableRow>

              {/* Airline */}
              <TableRow>
                <TableCell style={headerCellStyle}>Airline</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.airline || "-"}
                </TableCell>
              </TableRow>

              {/* Flight No. */}
              <TableRow>
                <TableCell style={headerCellStyle}>Flight No.</TableCell>
                <TableCell style={cellStyle}>
                  {formContent?.flightNo || "-"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Remarks */}
        {formContent?.remarks?.trim()?.length > 0 && (
          <div className="mt-2 pe-1 mb-0">
            <Typography
              variant="body1"
              className="text-start"
              gutterBottom
              style={{ fontSize: "10px" }}
              component="div"
            >
              <DynamicText
                label="Remarks / Instructions (If any)"
                textAreaLabel="Remarks"
                isEdit={false}
                value={formContent?.remarks}
              />
            </Typography>
          </div>
        )}

        <Grid container className="mt-4">
          <Grid item xs={6} className="text-center">
            <div
              style={{ height: "70px" }}
              className="d-flex justify-content-center align-items-end"
            >
              {formContent?.managerSign?.trim()?.length > 0 && (
                <img
                  src={`${Bucket}${formContent?.managerSign}`}
                  height={60}
                  width={150}
                  style={{ objectFit: 'contain' }}
                  alt="Manager Sign"
                />
              )}
            </div>

            <p className="mb-0">{"_______________________________"}</p>
            <p className="my-0" style={{ fontSize: "12px" }}>
              <b>{"Manager Operations"}</b>
            </p>
          </Grid>
          <Grid item xs={6} className="text-center">
            <div
              style={{ height: "70px" }}
              className="d-flex justify-content-center align-items-end"
            >
               {formContent?.assistOperSign?.trim()?.length > 0 && (
                <img
                  src={`${Bucket}${formContent.assistOperSign}`}
                  height={60}
                  width={150}
                  style={{ objectFit: 'contain' }}
                  alt="Assistant Sign"
                />
              )}
            </div>
            <p className="mb-0">{"_______________________________"}</p>
            <p className="my-0" style={{ fontSize: "12px" }}>
              <b>{"Assistant Operations"}</b>
            </p>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export default WorksheetImportDownload;
